import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=35d9e956&scoped=true&"
import script from "./Auth.vue?vue&type=script&lang=js&"
export * from "./Auth.vue?vue&type=script&lang=js&"
import style0 from "./Auth.scss?vue&type=style&index=0&id=35d9e956&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d9e956",
  null
  
)

export default component.exports